import { FC } from 'react'

import { SettingsPageLayout } from '../components/SettingsPageLayout'
import { SettingsGroup } from '@sequencehq/core-components'

import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dist/clients/dashboard/v20240730'
import { SETTINGS_STALE_TIME } from '../settings.constants'
import { MerchantSupportSettings } from '../components/merchant/MerchantSupportSettings'
import { MerchantAlertSettings } from '../components/merchant/MerchantAlertSettings'
import { MerchantSettings } from '../components/merchant/MerchantSettings'
import { MerchantAddressSettings } from '../components/merchant/MerchantAddressSettings'

export const MerchantSettingsPage: FC = () => {
  const sequenceAccountId = useQuery(
    dashboard20240730Client.getSequenceAccountId,
    undefined
  )

  const sequenceAccount = useQuery(
    dashboard20240730Client.getSequenceAccount,
    { id: sequenceAccountId?.data?.id ?? '' },
    {
      staleTime: SETTINGS_STALE_TIME,
      enabled: Boolean(sequenceAccountId?.data?.id)
    }
  )

  const merchant = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount,
    undefined,
    {
      staleTime: SETTINGS_STALE_TIME
    }
  )

  return (
    <SettingsPageLayout
      header="Merchant"
      isError={
        merchant.isError ||
        sequenceAccount.isError ||
        sequenceAccountId?.isError
      }
      subheader={`Manage ${merchant.data?.legalCompanyName ?? ''} details for invoices and credit notes`}
    >
      <SettingsGroup isLoading={merchant.isLoading} rows={3}>
        {merchant.data && <MerchantSettings merchant={merchant.data} />}
      </SettingsGroup>

      <SettingsGroup
        title="Company address"
        height={272}
        isLoading={merchant.isLoading}
      >
        {merchant.data && <MerchantAddressSettings merchant={merchant.data} />}
      </SettingsGroup>

      <SettingsGroup
        title="Support"
        footer="Display support information on hosted invoices."
        isLoading={merchant.isLoading}
        rows={2}
      >
        {merchant.data && <MerchantSupportSettings merchant={merchant.data} />}
      </SettingsGroup>

      <SettingsGroup
        title="Alert"
        footer="Separate multiple emails using commas."
        isLoading={sequenceAccount.isLoading}
      >
        {sequenceAccount.data && (
          <MerchantAlertSettings
            id={sequenceAccount.data.id}
            alertEmail={sequenceAccount.data.alertEmailAddresses}
          />
        )}
      </SettingsGroup>
    </SettingsPageLayout>
  )
}
